import { render, staticRenderFns } from "./BuyNowModal.vue?vue&type=template&id=4cad4f62&"
import script from "./BuyNowModal.vue?vue&type=script&lang=js&"
export * from "./BuyNowModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports